import React, { useEffect, useState, useContext } from 'react';
import { 
  ChakraProvider,  
} from '@chakra-ui/react'
import Home from './Home';
import Loading from './components/Loading/Loading';
import { WrongParams, WrongOlympId, ServerError } from './components/ErrorPages/ErrorPages';
import { LinkContext } from './LinkContext';
import Axios from 'axios';

function App() {
  const context = useContext(LinkContext);
  const [olympId, setOlympId] = useState(-1);
  const [olympInfo, setOlympInfo] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);
  const [wrongOlympId, setWrongOlympId] = useState(false);
  const [serverError, setServerError] = useState(false);

  

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let olympIdFromUrl = -1;

    for (const [param, value] of Array.from(searchParams.entries())) {
      if (param === 'olympId') {
        olympIdFromUrl = Number(value);
      }
    }

    Axios
      .get(`${context}/lk/api/olymp_guide/get/${olympIdFromUrl}`)
      .then((response) => {
        setOlympId(olympIdFromUrl);
        setOlympInfo(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.status === 500) {
          setWrongOlympId(true);
          setIsLoading(false);
        } else {
          setServerError(true);
          setIsLoading(false);
        }
      });
  }, [context]);

  return (
    <ChakraProvider>
      {serverError ? 
        <ServerError /> :
        olympId === -1 && !isLoading ?
        <WrongParams /> :
        wrongOlympId ?
        <WrongOlympId /> :
        isLoading ?
        <Loading /> :
        <Home olympInfo={olympInfo} />
      }
    </ChakraProvider>
  );
}

export default App;
